import React from "react";

import TVShowList from "../../components/show/TVShowList";
import Banner from "../../components/Banner";
import NavBar from "../../components/Navbar";
import Section from "../../components/Section";

function TVShows() {
    
    return (
        <>
            <NavBar />
            <Banner />

            <Section title="Trending TV Shows"  >
                <TVShowList />
            </Section>
        </>
    );
}

export default TVShows;
